
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1epxo_12cv0_5",
  "dismiss-button": "awsui_dismiss-button_1epxo_12cv0_6"
};
  